import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 43668 43785"
    {...props}
  >
    <defs>
      <style>
        {
          // ".str0{stroke:#000;stroke-width:638.943;stroke-linecap:round;stroke-linejoin:round}.fil0{fill:none}"
        }
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2528318537440">
        <path
          d="M320 319h43028v3354H320zM1047 3246v39540M15271 43049l179-39803M1047 42846c605 10 1176 203 1586 203 631 0 631-527 1263-527 631 0 631 527 1263 527 631 0 631-527 1262-527s631 527 1262 527 631-527 1262-527c632 0 632 527 1264 527s632-527 1264-527 632 527 1265 527 633-527 1266-527c634 0 634 527 1267 527M8411 42122V22792M4876 42522V31442M11834 42122V27882M42851 26418S29253 22750 29586 3675"
          className="fill-none stroke1"
          style={{
            strokeWidth: 638.943,
            strokeLinejoin: "round",
          }}
        />
        <path
          d="M40572 21830c-2332-1778-4960-4640-6627-9121M38888 24774c-5593-1262-12663-7648-12609-20831"
                    className="fill-none stroke1"
          style={{
            strokeWidth: 638.943,
            strokeLinejoin: "round",
          }}

        />
        <path
          d="m39536 24881-3770 17545c-114 522 191 1040 612 1040h6474l-8-39518M38247 25337l-4384 15947c-150 546 124 1142 526 1142h1212M38247 43466l1050-7529M40875 43106l277-4093"
                    className="fill-none stroke1"
          style={{
            strokeWidth: 638.943,
            strokeLinejoin: "round",
          }}

        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
